/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAddressV1Dto } from '../models/CreateAddressV1Dto';
import type { CreateLocationToPartnerV1Dto } from '../models/CreateLocationToPartnerV1Dto';
import type { CreateLocationV1Dto } from '../models/CreateLocationV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { LocationToAddressV1Dto } from '../models/LocationToAddressV1Dto';
import type { LocationToPartnerV1Dto } from '../models/LocationToPartnerV1Dto';
import type { LocationV1Dto } from '../models/LocationV1Dto';
import type { PatchLocationToPartnerV1Dto } from '../models/PatchLocationToPartnerV1Dto';
import type { UpdateLocationV1Dto } from '../models/UpdateLocationV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LocationsService {
  /**
   * @returns LocationV1Dto a entity list
   * @throws ApiError
   */
  public static locationControllerV1FindAllV1(): CancelablePromise<Array<LocationV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/locations',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns LocationV1Dto create entity
   * @throws ApiError
   */
  public static locationControllerV1CreateV1(
    requestBody: CreateLocationV1Dto,
  ): CancelablePromise<LocationV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/locations',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static locationControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/locations',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid locationId
   * @returns LocationV1Dto the entity
   * @throws ApiError
   */
  public static locationControllerV1FindOneV1(uuid: string): CancelablePromise<LocationV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/locations/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid
   * @param requestBody
   * @returns LocationV1Dto the update entity
   * @throws ApiError
   */
  public static locationControllerV1UpdateV1(
    uuid: string,
    requestBody: UpdateLocationV1Dto,
  ): CancelablePromise<LocationV1Dto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/v1/locations/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid locationId
   * @returns LocationV1Dto the entity
   * @throws ApiError
   */
  public static locationControllerV1RemoveOneV1(uuid: string): CancelablePromise<LocationV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/locations/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid locationId
   * @returns LocationToPartnerV1Dto a entity list
   * @throws ApiError
   */
  public static locationControllerV1FindAllLocationToPartnerV1(
    uuid: string,
  ): CancelablePromise<Array<LocationToPartnerV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/locations/{uuid}/partners',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid locationId
   * @param requestBody
   * @returns LocationToPartnerV1Dto create entity
   * @throws ApiError
   */
  public static locationControllerV1CreateLocationToPartnerV1(
    uuid: string,
    requestBody: CreateLocationToPartnerV1Dto,
  ): CancelablePromise<LocationToPartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/locations/{uuid}/partners',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid locationId
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static locationControllerV1RemoveManyLocationToPartnerV1(
    uuid: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/locations/{uuid}/partners',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid locationId
   * @param locationToPartnerId locationToPartnerId
   * @returns LocationToPartnerV1Dto the entity
   * @throws ApiError
   */
  public static locationControllerV1FindOneLocationToPartnerV1(
    uuid: string,
    locationToPartnerId: string,
  ): CancelablePromise<LocationToPartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/locations/{uuid}/partners/{locationToPartnerId}',
      path: {
        uuid: uuid,
        locationToPartnerId: locationToPartnerId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid locationId
   * @param locationToPartnerId locationToPartnerId
   * @param requestBody
   * @returns LocationToPartnerV1Dto the update entity
   * @throws ApiError
   */
  public static locationControllerV1UpdatePartialLocationToPartnerV1(
    uuid: string,
    locationToPartnerId: string,
    requestBody: PatchLocationToPartnerV1Dto,
  ): CancelablePromise<LocationToPartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/locations/{uuid}/partners/{locationToPartnerId}',
      path: {
        uuid: uuid,
        locationToPartnerId: locationToPartnerId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid locationId
   * @param locationToPartnerId locationToPartnerId
   * @returns LocationToPartnerV1Dto the entity
   * @throws ApiError
   */
  public static locationControllerV1RemoveLocationToPartnerV1(
    uuid: string,
    locationToPartnerId: string,
  ): CancelablePromise<LocationToPartnerV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/locations/{uuid}/partners/{locationToPartnerId}',
      path: {
        uuid: uuid,
        locationToPartnerId: locationToPartnerId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param locationUuid locationId
   * @param requestBody
   * @returns LocationToAddressV1Dto create entity
   * @throws ApiError
   */
  public static locationToAddressControllerV1CreateAddressV1(
    locationUuid: string,
    requestBody: CreateAddressV1Dto,
  ): CancelablePromise<LocationToAddressV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/locations/{locationUuid}/address',
      path: {
        locationUuid: locationUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param locationUuid locationId
   * @param addressUuid addressId
   * @returns LocationToAddressV1Dto create entity
   * @throws ApiError
   */
  public static locationToAddressControllerV1LinkAddressV1(
    locationUuid: string,
    addressUuid: string,
  ): CancelablePromise<LocationToAddressV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/locations/{locationUuid}/address/{addressUuid}',
      path: {
        locationUuid: locationUuid,
        addressUuid: addressUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param locationUuid locationId
   * @param addressUuid addressId
   * @returns LocationToAddressV1Dto the entity
   * @throws ApiError
   */
  public static locationToAddressControllerV1UnlinkAddressV1(
    locationUuid: string,
    addressUuid: string,
  ): CancelablePromise<LocationToAddressV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/locations/{locationUuid}/address/{addressUuid}',
      path: {
        locationUuid: locationUuid,
        addressUuid: addressUuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param locationUuid locationId
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static locationToAddressControllerV1UnlinkManyAddressesV1(
    locationUuid: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/locations/{locationUuid}/addresses',
      path: {
        locationUuid: locationUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
